import { tokenStore } from "store/token.store";
import userStore from "store/user.store";

export const isLoggedIn = () => {
  const { user } = userStore.getState();
  const accessToken = tokenStore.getAccessToken();

  if (!user || !accessToken) {
    return false;
  }

  if (tokenStore.refreshTokenHasExpired()) {
    return false;
  }

  return true;
};
